import React from "react";
import { motion } from "motion/react";
import { fadeIn } from "../utils/motion";

// Card Component for General Use
const Card = ({ 
  title, 
  image, 
  paragraph, 
  icon, 
  index, 
  investment, 
  profit, 
  rewardIcon, 
  time // New 'time' prop for plan duration
}) => {
  // If 'investment', 'profit', 'rewardIcon', and 'time' are passed, render the investment card layout
  if (investment && profit && rewardIcon) {
    return (
      <motion.div
        className="card glass max-w-[300px] shadow-xl"
        variants={fadeIn("right", "spring", 0.5 * index, 0.75)}
      >
        <div className="card-body text-white">
          <h2 className="card-title flex items-center">
            {rewardIcon && <span className="mr-2">{rewardIcon}</span>}
            {title}
          </h2>
          <p className="text-lg">Investment: ${investment}</p>
          {/* Apply the bright green color for profit */}
          <p className="text-lg text-green-500">Profit: ${profit}</p>
          {/* Display the 'time' duration */}
          <p className="text-lg text-gray-300">Duration: {time}</p>
          <div className="card-actions justify-end">
            <button className="btn btn-primary bg-secondary-500 border-none hover:bg-secondary-600">
              Invest Now
            </button>
          </div>
        </div>
      </motion.div>
    );
  }

  // Default Card Layout (for title, image, paragraph, icon)
  return (
    <motion.div
      className="card glass max-w-[300px] shadow-xl"
      variants={fadeIn("right", "spring", 0.5 * index, 0.75)}
    >
      {image && (
        <figure>
          <img src={image} alt={`${title}-image`} className="w-full h-auto" />
        </figure>
      )}
      <div className="card-body text-white">
        <h2 className="card-title flex items-center">
          {icon && <span className="mr-2">{icon}</span>}
          {title}
        </h2>
        <p>{paragraph}</p>
        <div className="card-actions justify-end">
          <button className="btn btn-primary bg-secondary-500 border-none hover:bg-secondary-600">
            Get Started
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default Card;
